"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeBooksInteriorPrintables;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const either_1 = require("../../types/either");
/**
 * This function will reduce the number of printables in a book interior printable group to the number of pages
 * dictated by the template's max page count.
 * @param userId
 * @param projectId
 * @param creationDate
 * @param template
 * @param options
 * @param designId
 * @param currentPrintableGroups
 * @returns
 */
function removeBooksInteriorPrintables(template, currentPrintableGroups, hasBoxPrintableGroup) {
  const coverGroup = (0, lodash_clonedeep_1.default)(currentPrintableGroups === null || currentPrintableGroups === void 0 ? void 0 : currentPrintableGroups.find(pg => pg.type === 'cover'));
  const interiorGroup = (0, lodash_clonedeep_1.default)(currentPrintableGroups === null || currentPrintableGroups === void 0 ? void 0 : currentPrintableGroups.find(pg => pg.type === 'interior'));
  const woodenBoxGroup = hasBoxPrintableGroup ? (0, lodash_clonedeep_1.default)(currentPrintableGroups === null || currentPrintableGroups === void 0 ? void 0 : currentPrintableGroups.find(pg => pg.type === 'wooden-box')) : undefined;
  if (!coverGroup || !interiorGroup) {
    return (0, either_1.left)(new Error('Hmm these printable groups dont look like they\'re part of a book project...'));
  }
  // ... What do we do here if the page count is not dictated by the template? ex books with custom page counts
  interiorGroup.printables = interiorGroup.printables.slice(0, template.pages.max);
  if (hasBoxPrintableGroup && woodenBoxGroup) {
    return (0, either_1.right)([coverGroup, interiorGroup, woodenBoxGroup]);
  }
  return (0, either_1.right)([coverGroup, interiorGroup]);
}